import type { CreateEventSchema, UpdateEventSchema } from '@/api/events/event.schema';
import type { Event } from 'generated/prisma/browser';
import { createCrudHooks } from './create-crud-hooks';

export type EventWithCount = Event & { _count?: { couples: number } };

export const {
  keys: eventKeys,
  useDetail: useEvent,
  useList: useEvents,
  useCreate: useCreateEvent,
  useUpdate: useUpdateEvent,
  useDelete: useDeleteEvent,
} = createCrudHooks<EventWithCount, CreateEventSchema, UpdateEventSchema>('events');
